/** Shared customer-facing sentences, so the page, the preview and the poster say the same thing. */

/** Thank-you-first opener, keyed by the industry's subject noun (design doc 1.1). */
export function thankYouLine(subjectNoun: string | null | undefined): string {
  switch (subjectNoun) {
    case "매장":
      return "들러 주셔서 고마워요.";
    case "앱":
      return "써 주셔서 고마워요.";
    case "상품":
      return "골라 주셔서 고마워요.";
    default:
      return "찾아 주셔서 고마워요.";
  }
}

export const HELPER_SUBLINE = "몇 번만 누르면 후기 초안을 써 드려요. 고쳐서 직접 올려 주시면 돼요.";
export const NOT_STORED_LINE = "고르신 내용과 초안은 저장하지 않아요.";
/** Tail lines exactly as the server appends them (api/services/drafts.py), after a blank line. */
export const SPONSORED_TAIL = "제품을 제공받아 쓴 후기예요.";
export const AI_TAIL = "AI 도움을 받아 썼어요.";
